import React from 'react'
import { Icon } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'


const WarningAlert: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div
      style={{
        backgroundColor: '#FFFBE0',
        border: '1px solid #FFEB66',
        padding: '9px 16px',
        color: '#222222',
        marginTop: '8px',
      }}
    >
      <Icon name="info-circle" color="#FFEB66" />&ensp;
      <span>{t('e_pc_benefit_warning', '离职后员工津贴不可用，请谨慎操作')}</span>
    </div>
  )
}

export default WarningAlert
